export const VIDEO_BROADCAST_EVENTS = {
  START_RECORDING: 'START_RECORDING',
  START_VIDEO_AND_SCREEN_RECORDING: 'START_VIDEO_AND_SCREEN_RECORDING',
  START_SCREEN_RECORDING: 'START_SCREEN_RECORDING',
  STOP_RECORDING: 'STOP_RECORDING',
  POPUP_STATUS_RESPONSE: 'POPUP_STATUS_RESPONSE',
  OPEN_RECORDINGS_MODAL: 'OPEN_RECORDINGS_MODAL',
  POPUP_STATUS: 'POPUP_STATUS'
}
export const VIDEO_BROADCAST_CHANNEL = 'video_screen_recording_channel';
